/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Descriptions } from './descriptions';
import { EntityInfo } from './entityInfo';
import { HealthLevel } from './healthLevel';


export interface InventoryHealth { 
    children: Array<InventoryHealth>;
    /**
     * Details about the health information
     */
    descriptions?: Array<Descriptions>;
    entity_info: EntityInfo;
    health_level: HealthLevel;
    /**
     * ID
     */
    id: string;
    /**
     * More indepth Details
     */
    internal_descriptions?: Array<string>;
    /**
     * Name of the component
     */
    name: string;
}
export namespace InventoryHealth {
}


